import React from 'react';

const Quote = () => (
  <div className="quote">
    <p>“Calculators can only calculate - they cannot do mathematics”</p>
    <h1>-- John A. Van de Walk --</h1>
  </div>
);

export default Quote;
